// @flow

import React, { Component } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Helpers
import classNames from 'classnames';
import styles from 'components/Button.scss';

/**
 * <Button /> component.
 * @return {object} -
 */
export default class Button extends Component<*> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {string} className - class name for button.
   * @prop {string} defaultInputText - Default input text.
   * @prop {string} searchButtonText - Default Button text.
   */
  static propTypes = {
    buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    buttonSuffix: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
      PropTypes.object
    ]),
    onClick: PropTypes.func,
    href: PropTypes.string,
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    dataBi: PropTypes.string,
    dataSection: PropTypes.string,
    productId: PropTypes.string,
    dataElemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    attributeType: PropTypes.oneOf(['button', 'reset', 'submit']),
    attributeTarget: PropTypes.oneOf(['_blank', '_parent', '_self', '_top']),
    size: PropTypes.oneOf(['large', 'small']),
    type: PropTypes.oneOf(['primary', 'secondary', 'transparent']),
    boxShadow: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
    make: PropTypes.string,
    model: PropTypes.string,
    generation: PropTypes.string,
    derivative: PropTypes.string,
    trim: PropTypes.string,
    bodyType: PropTypes.string,
    fuelType: PropTypes.string,
    range: PropTypes.string,
    transmission: PropTypes.string
  };
  /**
   * Implements defaultProps().
   *
   * @return {Object} - propType object.
   * @prop {string} defaultText - Default input text.
   */
  static defaultProps: Object = {
    attributeType: 'button',
    size: 'large',
    type: 'primary',
    boxShadow: 'black',
    attributeTarget: '_blank'
  };

  getType: () => string = () => {
    const { type } = this.props;
    const { classButtonSecondary, classButtonTransparent } = styles;
    let typeBtn = '';
    if (type === 'secondary') {
      typeBtn = classButtonSecondary;
    } else if (type === 'transparent') {
      /* istanbul ignore else */
      typeBtn = classButtonTransparent;
    }
    return typeBtn;
  };

  getSize: () => string = () => {
    const { size } = this.props;
    const { classButtonLarge, classButtonSmall } = styles;
    let sizeBtn = '';
    switch (size) {
      case 'large':
        sizeBtn = classButtonLarge;
        break;
      case 'small':
        sizeBtn = classButtonSmall;
    }
    return sizeBtn;
  };

  /**
   * Renders <Button /> component.
   *
   * @return {JSX} - renders a Button.
   */
  render(): Element<*> | null {
    const {
      buttonText,
      buttonSuffix,
      extendStyle,
      attributeType,
      href,
      attributeTarget,
      boxShadow,
      rel,
      dataBi,
      dataSection,
      productId,
      make,
      model,
      generation,
      derivative,
      trim,
      bodyType,
      fuelType,
      range,
      transmission
    } = this.props;
    const { classButton, classButtonWhiteShadow } = styles;

    const Tag = href ? 'a' : 'button';
    const buttonAttributeType = Tag === 'button' ? attributeType : 'media_type';
    const sizeClass = this.getSize();
    const typeClass = this.getType();
    const boxShadowClass = boxShadow === 'white' ? classButtonWhiteShadow : '';
    return (
      <Tag
        href={href || null}
        target={href ? attributeTarget : null}
        className={classNames([
          extendStyle,
          classButton,
          sizeClass,
          typeClass,
          boxShadowClass
        ])}
        onClick={this.props.onClick}
        type={buttonAttributeType}
        data-elemid={this.props.dataElemId}
        rel={rel}
        data-bi={dataBi || 'click'}
        data-section={dataSection}
        product-id={productId}
        make={make}
        model={model}
        generation={generation}
        derivative={derivative}
        trim={trim}
        bodytype={bodyType}
        fueltype={fuelType}
        range={range}
        transmission={transmission}
      >
        {buttonText}
        {buttonSuffix}
        {this.props.children}
      </Tag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Common/Button/index.js